module.exports = __webpack_public_path__ + "img/qc1.2ac6a250.png";